



































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import InvoiceBlockCard from '@/modules/invoicing/components/InvoiceBlockCard.vue';
import MailPopup from '@/modules/invoicing/components/MailPopup.vue';
import Card from '@/components/default/Card.vue';
import InvoiceDetailsCard from '@/modules/invoicing/components/InvoiceDetailsCard.vue';
import InvoicePaymentDialog from '@/modules/invoicing/components/InvoicePaymentDialog.vue';
import InvoiceDocument from '@/modules/invoicing/components/InvoiceDocument.vue';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxTabs } from 'devextreme-vue';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import {
  ArticleCategory,
  ArticleCategoryClient,
  CreateCreditNoteCommand,
  CreditNotesClient,
  InvoiceBlock,
  InvoiceDto,
  InvoiceLine,
  IInvoiceLine,
  InvoicesClient,
  InvoiceUpdateCommand,
  IQuotationDiscountLinesDto,
  QuotationDiscountLinesDto,
  QuotationsClient,
  SendInvoicesToAccountantCommand,
  Settings,
  SwaggerException,
} from '@/data/web-api-client';
import InvoicePaymentTable from '../components/InvoicePaymentTable.vue';
import ProjectIsOnHoldPopup from '@/components/projects/ProjectIsOnHoldPopup.vue';
import ArticleSummaryTable, { EntityType, SummaryItem } from '@/components/articles/articleSummaryTable.vue';
import { groupBy } from '@/helpers/Helper';
import moment from 'moment';
Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    InvoiceBlockCard,
    Card,
    InvoiceDetailsCard,
    MailPopup,
    InvoicePaymentDialog,
    DxLoadPanel,
    DxTabs,
    EventLogsTable,
    InvoiceDocument,
    InvoicePaymentTable,
    ProjectIsOnHoldPopup,
    ArticleSummaryTable,
  },
})
export default class InvoiceDetails extends Vue {
  entityType: EntityType = 'Invoice';

  public articleCategories: ArticleCategory[] = [];

  loading: boolean = true;
  initialised: boolean = false;
  saving: boolean = false;
  dirty: boolean = false;
  navIndex: number = 0;
  invoice: InvoiceDto | null = null;
  client: InvoicesClient = new InvoicesClient(undefined, this.$axios);
  leftPositionBottomBar: number = 0;
  generatingCreditNote: boolean = false;
  toggled: boolean = false;
  companyContactObjects: any[] = [];
  disabled = false;

  declare currency: any;
  quotationDiscountLines: IQuotationDiscountLinesDto = new QuotationDiscountLinesDto();

  async created() {
    await this.loadData();
  }

  mounted() {
    if (document) {
      const bar = document.getElementById('savebar');

      if (bar) {
        const rect = bar.getBoundingClientRect();
        this.leftPositionBottomBar -= rect.left;
      }
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.dirty) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  async createCreditnote() {
    if (this.invoice && confirm('Bent u zeker dat u van deze factuur een creditnota wilt maken?')) {
      try {
        this.generatingCreditNote = true;
        const result = await new CreditNotesClient(undefined, this.$axios).create(
          new CreateCreditNoteCommand({
            invoiceId: this.invoice.id!,
          })
        );

        notificationService.showSuccessMessage('Creditnota is aangemaakt');

        this.$router.push({ path: `/creditnotes/${result}` });
      } catch (err) {
        notificationService.showAxiosError(err);
      } finally {
        this.generatingCreditNote = false;
      }
    }
  }

  async removeBlock(index: number) {
    if (!this.invoice || !this.invoice.blocks) {
      return;
    }

    this.invoice.blocks.splice(index, 1);
  }

  async removeInvoice() {
    if (this.invoice && confirm(this.$t('messages.AreYouSure') as string)) {
      this.client.remove(this.invoice.id!);
      this.$router.push('/invoices');
    }
  }

  async publishInvoice() {
    try {
      if (this.dirty) {
        this.save();
      }

      this.saving = true;

      if (this.invoice && confirm(this.$t('messages.AreYouSure') as string)) {
        await this.client.publish(this.invoice.id!);
        this.loadData();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  async setPaid() {
    if (this.dirty) {
      await this.save();
    }

    (this.$refs.paymentDialog as InvoicePaymentDialog).show = true;
  }

  async loadData() {
    try {
      this.loading = true;
      this.invoice = await this.client.getInvoice(this.$route.params.id);
      this.articleCategories = await new ArticleCategoryClient(undefined, this.$axios).get();

      if (this.invoice.quotationIdsInLines != null) {
        this.quotationDiscountLines = await new QuotationsClient(undefined, this.$axios).getDiscountLinesOfQuotations(this.invoice.quotationIdsInLines);
      }

      this.disabled = this.invoice.projectIsOnHold!;

      setTimeout(() => {
        this.initialised = true;

        if (this.$route.query.checkProjectOnHold === 'true' && this.invoice?.projectIsOnHold) {
          this.projectIsOnHoldPopup.show();
        }
      }, 400);
    } catch (err) {
      notificationService.failedToLoad();
    } finally {
      setTimeout(() => {
        this.loading = false;
      }, 200);
    }
  }

  async save() {
    if (!this.invoice) {
      return;
    }
    this.saving = true;
    this.invoice.total = this.total;
    this.invoice.totalDiscount = this.totalDiscount;
    this.invoice.totalWithoutDiscount = this.totalWithoutDiscount;
    this.invoice.date = this.validInvoiceDate;

    const command = new InvoiceUpdateCommand(this.invoice);
    command.init(this.invoice);
    await this.client
      .update(this.invoice.id!, command)
      .then(() => {
        this.dirty = false;
        notificationService.saved();
      })
      .catch((err: SwaggerException) => {
        if (err.response.includes('Invoice Date has to be in current month or equal to last day of previous month')) {
          notificationService.showErrorMessage(this.$t('objects.invoices.InvalidDateerror').toString());
        } else {
          notificationService.showAxiosError(err);
        }
      })
      .finally(() => {
        setTimeout(() => {
          this.saving = false;
        }, 200);
      });
  }

  createBlock() {
    if (!this.invoice) {
      return;
    }

    if (!this.invoice.blocks) {
      this.invoice.blocks = [];
    }

    const name = prompt('Geef de naam van de nieuwe blok op', '');
    if (name && name !== '') {
      this.invoice.blocks.push(
        new InvoiceBlock({
          showTitle: true,
          showTotals: true,
          title: name,
          lines: [],
          total: 0,
          originalTotal: 0,
          totalDifference: 0,
          margin: 0,
        })
      );
    }
  }

  async sendToAccountant() {
    const invoiceIds = [this.invoice!.id!];

    if (invoiceIds.length === 0) {
      return;
    }

    const command = new SendInvoicesToAccountantCommand({
      invoiceIds: [...invoiceIds],
    });

    try {
      await this.client.sendToAccountant(command);

      notificationService.showNotification('De factuur wordt in de achtergrond verstuurd naar de boekhouding', 'info');
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  get codeSummary(): SummaryItem[] {
    const summaryByCategories = this.settings.summaryInCategories;
    let result: SummaryItem[] = [];

    if (summaryByCategories) {
      if (!this.invoice || !this.invoice.blocks) {
        return result;
      }

      const allLinesWithoutDefaultBlock = this.invoice.blocks.filter((b) => b.lines && b.title != 'Standaardkosten').flatMap((b) => b.lines);
      const allDefaultBlockLines = this.invoice.blocks.filter((b) => b.lines && b.title == 'Standaardkosten').flatMap((b) => b.lines);

      const groupedLinesByCategory: Map<string, InvoiceLine[]> = groupBy(allLinesWithoutDefaultBlock, 'articleCategoryId');

      for (const [key, values] of groupedLinesByCategory) {
        var groupedLines: Map<string, InvoiceLine[]> = groupBy(values, 'description');
        for (const [articleId, lines] of groupedLines) {
          if (lines.length == 0) continue;

          let line = lines[0];

          const quantitySum = lines.reduce((a: number, { quantity }) => a + quantity!, 0);
          const totalSum = lines.reduce((a: number, { total }) => a + total!, 0);
          const resultIndex = result.findIndex((o) => o.articleId === line.articleId && o.description === line.description);

          if (resultIndex === -1) {
            result.push({
              articleId: line.articleId!,
              description: line.description!,
              quantity: quantitySum!,
              unitPrice: totalSum!,
              articleCategoryId: line.articleCategoryId!,
            });
          } else {
            result[resultIndex].quantity += quantitySum;
            result[resultIndex].unitPrice += totalSum!;
          }
        }
      }

      const nullCatLines = result.filter((r) => r.articleCategoryId == null);
      const catLines = result.filter((r) => r.articleCategoryId != null);
      result = [...catLines, ...nullCatLines];

      var groupedDefaultBlockLines: Map<string, InvoiceLine[]> = groupBy(allDefaultBlockLines, 'description');
      for (const [articleId, lines] of groupedDefaultBlockLines) {
        if (lines.length == 0) continue;

        let line = lines[0];

        const quantitySum = lines.reduce((a: number, { quantity }) => a + quantity!, 0);
        const totalSum = lines.reduce((a: number, { total }) => a + total!, 0);

        const resultIndex = result.findIndex((o) => o.articleId === line.articleId && o.description === line.description);
        if (resultIndex === -1) {
          result.push({
            articleId: line.articleId!,
            description: line.description!,
            quantity: quantitySum,
            unitPrice: totalSum!,
            articleCategoryId: line.articleCategoryId!,
          });
        } else {
          result[resultIndex].quantity += quantitySum;
          result[resultIndex].unitPrice += totalSum!;
        }
      }

      result.forEach((resultItem) => {
        resultItem.unitPrice = resultItem.unitPrice / resultItem.quantity;
      });

      return result;
    }

    if (!this.invoice || !this.invoice.blocks) {
      return result;
    }

    for (const block of this.invoice.blocks.filter((b) => b.lines)) {
      for (const line of block.lines!) {
        if (line.articleId && line.articleId !== '' && line.quantity && line.total) {
          const resultIndex = result.findIndex((o) => o.articleId === line.articleId && o.description === line.description);
          if (resultIndex === -1) {
            result.push({
              articleId: line.articleId,
              description: line.description!,
              quantity: line.quantity,
              unitPrice: line.total,
              articleCategoryId: line.articleCategoryId!,
            });
          } else {
            result[resultIndex].quantity += line.quantity;
            result[resultIndex].unitPrice += line.total;
          }
        }
      }
    }

    result.forEach((resultItem) => {
      resultItem.unitPrice = resultItem.unitPrice / resultItem.quantity;
    });

    return result;
  }

  get navbarItems() {
    const self = this;
    return [
      { icon: 'fas fa-info-circle', text: 'Basis info' },
      { icon: 'fas fa-info-circle', text: 'Samenvatting' },
      { icon: 'fas fa-file-pdf', text: 'Document' },
      { icon: 'fas fa-history', text: 'Geschiedenis' },
      { icon: 'fas fa-money-bill', text: 'Betalingen' },
    ];
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: this.$route.params.id,
      type: EventLogsObjectType.Invoice,
    };
  }

  get totalDiscount() {
    return this.totalWithoutDiscount - this.total;
  }

  get totalWithoutDiscount() {
    let res = 0;
    if (!this.invoice || !this.invoice.blocks || this.invoice.blocks.length <= 0) {
      return res;
    }

    for (const block of this.invoice.blocks) {
      if (!block.lines || block.lines.length <= 0) {
        continue;
      }

      for (const line of block.lines) {
        if (!line.quantity || !line.price || isNaN(line.quantity!) || isNaN(line.price!)) {
          continue;
        }
        let linePrice = line.price;

        res += line.quantity * linePrice;
      }
    }

    return res;
  }

  get total() {
    let res = 0;
    if (!this.invoice || !this.invoice.blocks || this.invoice.blocks.length <= 0) {
      return res;
    }

    for (const block of this.invoice.blocks) {
      if (!block.lines || block.lines.length <= 0) {
        continue;
      }

      for (const line of block.lines) {
        if (!line.quantity || !line.price || isNaN(line.quantity!) || isNaN(line.price!)) {
          continue;
        }

        if (!line.quotationId) {
          res += line.quantity * line.price;
          continue;
        }

        const discountLines = this.quotationDiscountLines[line.quotationId];
        let linePrice = line.price;

        if (discountLines) {
          for (const dl of discountLines) {
            linePrice = linePrice * ((100 - dl.discountPercentage) / 100);
          }
        }

        res += line.quantity * linePrice;
      }
    }

    return res;
  }

  get totalWithTax() {
    if (!this.invoice || !this.invoice.blocks || this.invoice.blocks.length <= 0) {
      return 0;
    }

    return Math.round(this.total * (100 + this.invoice.taxRate!)) / 100;
  }

  get totalOriginal() {
    let res = 0;
    if (!this.invoice || !this.invoice.blocks || this.invoice.blocks.length <= 0) {
      return res;
    }

    this.invoice.blocks.forEach((block: any) => {
      if (block.lines && block.lines.length > 0) {
        block.lines.forEach((line: any) => {
          if (line.quantity && line.originalPrice) {
            res += line.quantity * line.originalPrice;
          }
        });
      }
    });

    return res;
  }

  get margin() {
    let res = 0;
    if (!this.invoice || !this.invoice.blocks || this.invoice.blocks.length <= 0) {
      return res;
    }

    this.invoice.blocks.forEach((block: any) => {
      if (block.lines && block.lines.length > 0) {
        block.lines.forEach((line: any) => {
          const cost = line.cost ? line.cost : 0; // get cost

          // Calculate margin
          if (line.quantity && line.price) {
            res += line.quantity * (line.price - cost);
          }
        });
      }
    });

    return res;
  }

  get validInvoiceDate(): Date {
    const invoiceDate: Date | string = this.invoice?.date!;

    if (typeof invoiceDate == 'string') {
      const invoiceDateString: string = invoiceDate;

      const [year, month, day] = invoiceDateString.split('-');

      return new Date(Number(year), Number(month) - 1, Number(day), 13, 0, 0);
    }

    return invoiceDate;
  }

  get marginPercent() {
    const percent = (this.margin / this.total) * 100;
    if (!isFinite(percent)) {
      return '';
    }
    return percent.toFixed(2) + '%';
  }

  get projectIsOnHoldPopup() {
    return this.$refs.projectIsOnHoldPopup as ProjectIsOnHoldPopup;
  }

  get settings(): Settings {
    return this.$store.getters['settings/data'];
  }

  @Watch('navIndex')
  onNavigationChanged(newIndex: number) {
    if (newIndex === 1) {
      // this.loadDocument();
    }
  }

  @Watch('invoice', { deep: true })
  onQuotationChanged() {
    if (!this.loading && this.initialised) {
      this.dirty = true;
    }
  }
}
